var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-gray-50 text-gray-900 min-h-screen p-6 font-sans" },
    [
      _c(
        "div",
        {
          staticClass:
            "max-w-[1400px] mx-auto space-y-6 flex flex-col h-[calc(100vh-3rem)]",
          attrs: { id: "app" },
        },
        [
          _c(
            "header",
            { staticClass: "border-b border-gray-200 pb-4 shrink-0" },
            [
              _c("div", { staticClass: "flex items-center justify-between" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "flex items-center space-x-4" }, [
                  _c(
                    "div",
                    {
                      staticClass: "flex items-center",
                      class: {
                        "text-brand font-bold": _vm.step === 1,
                        "text-gray-500": _vm.step !== 1,
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "w-8 h-8 rounded-full flex items-center justify-center border-2 mr-2",
                          class:
                            _vm.step >= 1
                              ? "border-brand bg-brand-light text-brand"
                              : "border-gray-300",
                        },
                        [_vm._v("\n              1\n            ")]
                      ),
                      _vm._v("\n            Draw Faces\n          "),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "w-12 h-0.5",
                    class: _vm.step >= 2 ? "bg-brand" : "bg-gray-300",
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "flex items-center",
                      class: {
                        "text-brand font-bold": _vm.step === 2,
                        "text-gray-500": _vm.step !== 2,
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "w-8 h-8 rounded-full flex items-center justify-center border-2 mr-2",
                          class:
                            _vm.step >= 2
                              ? "border-brand bg-brand-light text-brand"
                              : "border-gray-300",
                        },
                        [_vm._v("\n              2\n            ")]
                      ),
                      _vm._v("\n            Configure & 3D\n          "),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "w-12 h-0.5",
                    class: _vm.step >= 3 ? "bg-brand" : "bg-gray-300",
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "flex items-center",
                      class: {
                        "text-brand font-bold": _vm.step === 3,
                        "text-gray-500": _vm.step !== 3,
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "w-8 h-8 rounded-full flex items-center justify-center border-2 mr-2",
                          class:
                            _vm.step >= 3
                              ? "border-brand bg-brand-light text-brand"
                              : "border-gray-300",
                        },
                        [_vm._v("\n              3\n            ")]
                      ),
                      _vm._v("\n            Export\n          "),
                    ]
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "main",
            {
              staticClass:
                "flex-grow flex flex-col overflow-hidden relative mt-2",
            },
            [
              !_vm.uploadedImageSrc
                ? _c(
                    "b-button",
                    {
                      staticClass:
                        "btn-group-style custom-secondary-btn mb-2 shadow-none",
                      staticStyle: { "max-width": "150px" },
                      attrs: { size: "sm" },
                      on: { click: _vm.openSelectFolderModal },
                    },
                    [
                      _c("b-icon", {
                        staticClass: "mr-1",
                        attrs: { icon: "folder" },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-sm font-medium" }, [
                        _vm._v("File Browser"),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("SelectFolderModal", {
                attrs: { mode: "default" },
                on: { onSelectedItems: _vm.fileBrowserItemSelected },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.step === 1,
                      expression: "step === 1",
                    },
                  ],
                  staticClass:
                    "wizard-step flex flex-col h-full w-full relative",
                },
                [
                  _vm.isImageLoading
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "absolute inset-0 bg-white/60 backdrop-blur-[2px] z-[100] flex flex-col items-center justify-center rounded-lg",
                        },
                        [
                          _vm._m(1),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "text-xl font-bold text-gray-900 mt-4",
                            },
                            [
                              _vm._v(
                                "\n            Processing Texture...\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "text-sm text-gray-500 mt-2" },
                            [
                              _vm._v(
                                "\n            Uploading and analyzing your image. Please wait.\n          "
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.uploadedImageSrc
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-wrap gap-4 mb-4 items-center bg-white border border-gray-200 p-4 rounded-lg shadow-sm shrink-0",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "px-4 py-2 border border-gray-300 rounded-md font-semibold hover:bg-gray-50 transition-colors flex items-center gap-2 text-gray-700",
                              on: { click: _vm.triggerFileInput },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "h-4 w-4",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "2",
                                      d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(
                                "\n            Change Texture\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass:
                                "btn-group-style custom-secondary-btn",
                              attrs: { size: "sm" },
                              on: { click: _vm.openSelectFolderModal },
                            },
                            [
                              _c("b-icon", {
                                staticClass: "mr-1",
                                attrs: { icon: "folder" },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "text-sm font-medium" },
                                [_vm._v("File Browser")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "px-4 py-2 text-white bg-red-600 hover:bg-red-700 rounded-md font-semibold transition-colors",
                              on: { click: _vm.clearSelection },
                            },
                            [
                              _vm._v(
                                "\n            Clear Selection\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "ml-4 flex items-center bg-brand-light border border-brand/20 rounded px-3 py-1",
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "text-brand font-bold mr-2" },
                                [_vm._v("Target Face:")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "text-brand font-medium" },
                                [_vm._v(_vm._s(_vm.currentPromptFace))]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "ml-auto flex items-center space-x-4",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "text-sm text-gray-500" },
                                [
                                  _vm._v("\n              Faces mapped: "),
                                  _c(
                                    "span",
                                    { staticClass: "font-bold text-gray-900" },
                                    [_vm._v(_vm._s(_vm.rectanglesMapped))]
                                  ),
                                  _vm._v(" / 6\n            "),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "px-6 py-2 btn-brand rounded-md font-bold transition-colors shadow-md flex items-center gap-2",
                                  attrs: {
                                    disabled:
                                      _vm.rectanglesMapped < 1 ||
                                      _vm.loadingStates.nextStep,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goToStep(2)
                                    },
                                  },
                                },
                                [
                                  _vm.loadingStates.nextStep
                                    ? _c("span", {
                                        staticClass: "button-spinner mr-1",
                                      })
                                    : _c("span", [_vm._v("Next Step")]),
                                  _vm._v(" "),
                                  !_vm.loadingStates.nextStep
                                    ? _c(
                                        "svg",
                                        {
                                          staticClass: "h-4 w-4",
                                          attrs: {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "stroke-width": "2",
                                              d: "M13 7l5 5m0 0l-5 5m5-5H6",
                                            },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "bg-white shadow-sm flex-grow flex flex-col relative overflow-hidden border-0",
                      class: {
                        "p-4": _vm.uploadedImageSrc,
                        "p-0": !_vm.uploadedImageSrc,
                      },
                    },
                    [
                      _vm.uploadedImageSrc
                        ? _c(
                            "div",
                            {
                              ref: "viewport",
                              staticClass:
                                "relative border border-gray-300 rounded bg-[#ebebeb] flex-grow overflow-hidden",
                              class: _vm.cursorClass,
                              attrs: { id: "canvas-viewport" },
                              on: {
                                mousedown: _vm.onMouseDown,
                                wheel: _vm.onWheel,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "absolute top-2 right-2 flex flex-col gap-1 z-10 bg-white/80 p-1 rounded shadow-sm",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "w-8 h-8 flex items-center justify-center bg-gray-200 hover:bg-gray-300 text-gray-800 rounded text-xl font-bold",
                                      on: {
                                        click: function ($event) {
                                          return _vm.applyZoom(1.2)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                +\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "w-8 h-8 flex items-center justify-center bg-gray-200 hover:bg-gray-300 text-gray-800 rounded text-xl font-bold",
                                      on: {
                                        click: function ($event) {
                                          return _vm.applyZoom(0.8)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                -\n              "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "absolute bottom-2 left-2 z-10 text-[10px] text-gray-700 bg-white/90 shadow-sm border border-gray-200 p-1.5 rounded pointer-events-none",
                                },
                                [
                                  _vm._v(
                                    "\n              Scroll: Zoom | Middle-Click: Pan | Left-Click & Drag: Draw\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.showOverlayPrompt
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20 text-5xl font-extrabold text-gray-900 text-center drop-shadow-md bg-white/80 px-6 py-4 rounded-xl fade-out border border-gray-200",
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.currentPromptFace) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "absolute top-0 left-0 origin-top-left",
                                  style: _vm.transformStyle,
                                },
                                [
                                  _c("canvas", {
                                    ref: "bgCanvas",
                                    staticClass: "block",
                                  }),
                                  _vm._v(" "),
                                  _c("canvas", {
                                    ref: "drawCanvas",
                                    staticClass:
                                      "absolute top-0 left-0 pointer-events-none",
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isImageLoading && !_vm.uploadedImageSrc
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "flex-grow flex flex-col items-center justify-center p-12 transition-all cursor-pointer group rounded-lg",
                              class: _vm.isDragging
                                ? "bg-brand-light border-2 border-brand border-dashed"
                                : "bg-gray-50 border-2 border-gray-200 border-dashed hover:border-brand",
                              on: {
                                dragover: function ($event) {
                                  $event.preventDefault()
                                  return _vm.onDragOver.apply(null, arguments)
                                },
                                dragleave: function ($event) {
                                  $event.preventDefault()
                                  return _vm.onDragLeave.apply(null, arguments)
                                },
                                drop: function ($event) {
                                  $event.preventDefault()
                                  return _vm.onDrop.apply(null, arguments)
                                },
                                click: _vm.triggerFileInput,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "w-20 h-20 bg-white rounded-2xl shadow-sm border border-gray-100 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform",
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "w-10 h-10 text-brand",
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "text-2xl font-bold text-gray-900 mb-2",
                                },
                                [
                                  _vm._v(
                                    "\n              Upload Source File\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._m(2),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("input", {
                        ref: "fileInput",
                        staticClass: "hidden",
                        attrs: { type: "file", accept: "image/*" },
                        on: { change: _vm.onFileChange },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.step === 2,
                      expression: "step === 2",
                    },
                  ],
                  staticClass: "wizard-step flex flex-col h-full w-full",
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex justify-between mb-4 shrink-0" },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "px-4 py-2 text-gray-800 bg-gray-200 hover:bg-gray-300 rounded-md font-semibold transition-colors flex items-center gap-2",
                          on: {
                            click: function ($event) {
                              return _vm.goToStep(1)
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "h-4 w-4",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M10 19l-7-7m0 0l7-7m-7 7h18",
                                },
                              }),
                            ]
                          ),
                          _vm._v("\n            Back\n          "),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex items-center space-x-4" },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "px-4 py-2 text-white bg-brand hover:bg-brand-dark rounded-md font-semibold transition-colors flex items-center gap-2 shadow-md",
                              on: { click: _vm.exportMappings },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "h-4 w-4",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 20 20",
                                    fill: "currentColor",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      "fill-rule": "evenodd",
                                      d: "M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
                                      "clip-rule": "evenodd",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(
                                "\n              Export Mappings\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "px-6 py-2 bg-brand hover:bg-brand-dark text-white rounded-md font-bold transition-colors shadow-md flex items-center gap-2",
                              attrs: {
                                disabled: _vm.loadingStates.reviewExport,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.goToStep(3)
                                },
                              },
                            },
                            [
                              _vm.loadingStates.reviewExport
                                ? _c("span", {
                                    staticClass: "button-spinner mr-1",
                                  })
                                : _c("span", [_vm._v("Review & Export")]),
                              _vm._v(" "),
                              !_vm.loadingStates.reviewExport
                                ? _c(
                                    "svg",
                                    {
                                      staticClass: "h-4 w-4",
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2",
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "grid grid-cols-1 md:grid-cols-12 gap-6 flex-grow min-h-0",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "md:col-span-5 bg-white border border-gray-200 p-4 rounded-lg shadow-sm flex flex-col overflow-y-auto",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center justify-between mb-4 border-b border-gray-200 pb-2",
                            },
                            [
                              _c(
                                "h2",
                                {
                                  staticClass:
                                    "text-xl font-semibold text-gray-900",
                                },
                                [
                                  _vm._v(
                                    "\n                Reassign and Rotate Faces\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "tdr-face-export-btn tdr-face-export-all-btn shrink-0 flex items-center justify-center text-gray-700",
                                  attrs: {
                                    type: "button",
                                    title: "Download all faces (zip)",
                                    disabled: _vm.loadingStates.facesZip,
                                  },
                                  on: { click: _vm.exportAllFaceTexturesZip },
                                },
                                [
                                  _vm.loadingStates.facesZip
                                    ? _c("span", {
                                        staticClass: "button-spinner",
                                      })
                                    : _c(
                                        "svg",
                                        {
                                          staticClass: "h-4 w-4",
                                          attrs: {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 20 20",
                                            fill: "currentColor",
                                            "aria-hidden": "true",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              "fill-rule": "evenodd",
                                              d: "M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
                                              "clip-rule": "evenodd",
                                            },
                                          }),
                                        ]
                                      ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "space-y-4" },
                            _vm._l(_vm.faceConfigs, function (face, index) {
                              return _c(
                                "div",
                                {
                                  key: face.role,
                                  staticClass:
                                    "tdr-face-config-row bg-gray-50 p-3 rounded border border-gray-200 flex flex-col gap-2 relative",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex justify-between items-center gap-2 min-h-[2rem]",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "font-bold text-gray-700",
                                        },
                                        [_vm._v(_vm._s(face.role))]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex items-center gap-3 flex-nowrap",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex-grow flex flex-col min-w-0",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "custom-dropdown-container relative",
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "w-full h-9 bg-white text-gray-900 border border-gray-300 rounded-md px-2 text-sm flex items-center justify-between hover:border-brand transition-colors dropdown-toggle-custom",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.toggleDropdown(
                                                        index
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex items-center gap-2 overflow-hidden",
                                                    },
                                                    [
                                                      face.rectIndex !== null
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "w-6 h-6 rounded border border-gray-200 overflow-hidden shrink-0",
                                                            },
                                                            [
                                                              _c("img", {
                                                                staticClass:
                                                                  "w-full h-full object-cover",
                                                                attrs: {
                                                                  src: _vm.getFaceThumb(
                                                                    face.rectIndex,
                                                                    0
                                                                  ),
                                                                },
                                                              }),
                                                            ]
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "w-6 h-6 rounded border border-gray-200 bg-gray-50 flex items-center justify-center shrink-0",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "text-[8px] text-gray-400 font-bold uppercase",
                                                                },
                                                                [_vm._v("N/A")]
                                                              ),
                                                            ]
                                                          ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "truncate font-medium",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                            " +
                                                              _vm._s(
                                                                face.rectIndex !==
                                                                  null
                                                                  ? `Face ${
                                                                      face.rectIndex +
                                                                      1
                                                                    } (${
                                                                      _vm
                                                                        .rolePromptOrder[
                                                                        face
                                                                          .rectIndex
                                                                      ]
                                                                    })`
                                                                  : "None"
                                                              ) +
                                                              "\n                          "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "svg",
                                                    {
                                                      staticClass:
                                                        "h-4 w-4 text-gray-400",
                                                      attrs: {
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 20 20",
                                                        fill: "currentColor",
                                                      },
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          "fill-rule":
                                                            "evenodd",
                                                          d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
                                                          "clip-rule":
                                                            "evenodd",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.activeDropdown === index
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-xl overflow-y-auto max-h-60 custom-dropdown-menu",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "p-2 flex items-center gap-3 cursor-pointer hover:bg-gray-50 border-b border-gray-100 transition-colors dropdown-item-custom",
                                                          class: {
                                                            "bg-brand-light border-l-4 border-l-brand":
                                                              face.rectIndex ===
                                                              null,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.selectFace(
                                                                index,
                                                                null
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "w-10 h-10 rounded border border-gray-200 bg-gray-100 flex items-center justify-center text-gray-400 italic text-xs shrink-0",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            None\n                          "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-sm font-bold text-gray-500",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "No texture (Wireframe)"
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        _vm.rectangles,
                                                        function (rect, rIdx) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key: rIdx,
                                                              staticClass:
                                                                "p-2 flex items-center gap-3 cursor-pointer hover:bg-gray-50 border-b border-gray-100 transition-colors dropdown-item-custom",
                                                              class: {
                                                                "bg-brand-light border-l-4 border-l-brand":
                                                                  face.rectIndex ===
                                                                  rIdx,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.selectFace(
                                                                      index,
                                                                      rIdx
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "w-10 h-10 rounded border border-gray-300 overflow-hidden shrink-0 bg-white shadow-sm",
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    staticClass:
                                                                      "w-full h-full object-cover",
                                                                    attrs: {
                                                                      src: _vm.getFaceThumb(
                                                                        rIdx,
                                                                        0
                                                                      ),
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "flex flex-col min-w-0",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-sm font-bold text-gray-900 truncate",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Face " +
                                                                          _vm._s(
                                                                            rIdx +
                                                                              1
                                                                          )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-[10px] text-gray-500 font-medium uppercase truncate",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm
                                                                            .rolePromptOrder[
                                                                            rIdx
                                                                          ]
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "tdr-face-actions shrink-0",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "tdr-face-export-btn tdr-face-export-btn-float shrink-0 flex items-center justify-center text-gray-700",
                                              class: {
                                                "is-disabled":
                                                  face.rectIndex === null,
                                              },
                                              attrs: {
                                                type: "button",
                                                title:
                                                  "Download this face (full resolution)",
                                                disabled:
                                                  face.rectIndex === null,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  face.rectIndex === null
                                                    ? null
                                                    : _vm.exportFaceTexture(
                                                        index
                                                      )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  staticClass: "h-4 w-4",
                                                  attrs: {
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 20 20",
                                                    fill: "currentColor",
                                                    "aria-hidden": "true",
                                                  },
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      "fill-rule": "evenodd",
                                                      d: "M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
                                                      "clip-rule": "evenodd",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex items-center gap-2",
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "tdr-face-action-btn",
                                                  attrs: {
                                                    title: "Rotate 90° Left",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.rotateFaceConfig(
                                                        index,
                                                        -90
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      staticClass: "h-4 w-4",
                                                      attrs: {
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        stroke: "currentColor",
                                                        "stroke-width": "2",
                                                        "stroke-linecap":
                                                          "round",
                                                        "stroke-linejoin":
                                                          "round",
                                                      },
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("path", {
                                                        attrs: {
                                                          d: "M3 3v5h5",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "tdr-face-action-btn",
                                                  attrs: {
                                                    title: "Rotate 90° Right",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.rotateFaceConfig(
                                                        index,
                                                        90
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      staticClass: "h-4 w-4",
                                                      attrs: {
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        stroke: "currentColor",
                                                        "stroke-width": "2",
                                                        "stroke-linecap":
                                                          "round",
                                                        "stroke-linejoin":
                                                          "round",
                                                      },
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          d: "M21 12a9 9 0 1 1-9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("path", {
                                                        attrs: {
                                                          d: "M21 3v5h-5",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "tdr-face-action-btn",
                                                  class: {
                                                    "is-active": face.flipX,
                                                  },
                                                  attrs: {
                                                    title: "Flip Horizontally",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.flipFaceConfig(
                                                        index,
                                                        "x"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      staticClass: "h-4 w-4",
                                                      attrs: {
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        stroke: "currentColor",
                                                      },
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          "stroke-linecap":
                                                            "round",
                                                          "stroke-linejoin":
                                                            "round",
                                                          "stroke-width": "2",
                                                          d: "M8 7H5a2 2 0 00-2 2v6a2 2 0 002 2h3m8-10h3a2 2 0 012 2v6a2 2 0 01-2 2h-3M12 4v16",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "tdr-face-action-btn",
                                                  class: {
                                                    "is-active": face.flipY,
                                                  },
                                                  attrs: {
                                                    title: "Flip Vertically",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.flipFaceConfig(
                                                        index,
                                                        "y"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      staticClass: "h-4 w-4",
                                                      attrs: {
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        stroke: "currentColor",
                                                      },
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          "stroke-linecap":
                                                            "round",
                                                          "stroke-linejoin":
                                                            "round",
                                                          "stroke-width": "2",
                                                          d: "M17 8v-3a2 2 0 00-2-2H9a2 2 0 00-2 2v3m0 8v3a2 2 0 002 2h6a2 2 0 002-2v-3M4 12h16",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "md:col-span-7 bg-white border border-gray-200 p-4 rounded-lg shadow-sm flex flex-col relative w-full h-full min-h-[400px]",
                        },
                        [
                          _c(
                            "h2",
                            {
                              staticClass:
                                "text-xl font-semibold mb-2 text-gray-900",
                            },
                            [_vm._v("\n              3D Preview\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              ref: "threeContainerStep2",
                              staticClass:
                                "w-full aspect-video bg-[#ebebeb] rounded border border-gray-200 overflow-hidden relative mx-auto max-w-full",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "absolute top-2 left-2 z-10 text-[10px] text-gray-700 bg-white/90 border border-gray-200 p-2 rounded pointer-events-none font-mono shadow-sm",
                                },
                                [
                                  _c("div", [
                                    _vm._v(
                                      "OBJ POS: " +
                                        _vm._s(_vm.meshStats.pos.x) +
                                        ", " +
                                        _vm._s(_vm.meshStats.pos.y) +
                                        ", " +
                                        _vm._s(_vm.meshStats.pos.z)
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "OBJ ROT: " +
                                        _vm._s(_vm.meshStats.rot.x) +
                                        "°, " +
                                        _vm._s(_vm.meshStats.rot.y) +
                                        "°, " +
                                        _vm._s(_vm.meshStats.rot.z) +
                                        "°"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "CAM ZOOM: " +
                                        _vm._s(_vm.camStats.zoom) +
                                        "x"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "CAM FOV: " +
                                        _vm._s(_vm.camStats.fov) +
                                        "°"
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.step === 3,
                      expression: "step === 3",
                    },
                  ],
                  staticClass: "wizard-step flex flex-col h-full w-full",
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex justify-between mb-4 shrink-0" },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "px-4 py-2 text-gray-800 bg-gray-200 hover:bg-gray-300 rounded-md font-semibold transition-colors flex items-center gap-2",
                          on: {
                            click: function ($event) {
                              return _vm.goToStep(2)
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "h-4 w-4",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M10 19l-7-7m0 0l7-7m-7 7h18",
                                },
                              }),
                            ]
                          ),
                          _vm._v("\n            Back\n          "),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex gap-4" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "px-4 py-2 text-gray-800 bg-gray-200 hover:bg-gray-300 rounded-md font-semibold transition-colors flex items-center gap-2 shadow-sm",
                            on: { click: _vm.reset3DView },
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "h-5 w-5",
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 20 20",
                                  fill: "currentColor",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    "fill-rule": "evenodd",
                                    d: "M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 110 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z",
                                    "clip-rule": "evenodd",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(
                              "\n              Reset Camera\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "px-4 py-2 text-white bg-brand hover:bg-brand-dark rounded-md font-semibold transition-colors flex items-center gap-2 shadow-md",
                            on: { click: _vm.openVideoModal },
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "h-5 w-5",
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 20 20",
                                  fill: "currentColor",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(
                              "\n              Export as Video\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "px-6 py-2 btn-brand rounded-md font-bold transition-colors shadow-md flex items-center gap-2",
                            on: { click: _vm.export3DImage },
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "h-5 w-5",
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 20 20",
                                  fill: "currentColor",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    "fill-rule": "evenodd",
                                    d: "M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
                                    "clip-rule": "evenodd",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(
                              "\n              Export as Image\n            "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "bg-white border border-gray-200 p-4 rounded-lg shadow-sm flex-grow flex flex-col relative w-full h-full min-h-[400px]",
                    },
                    [
                      _vm._m(3),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          ref: "threeContainerStep3",
                          staticClass:
                            "w-full aspect-video bg-[#ebebeb] rounded border border-gray-200 overflow-hidden relative mx-auto max-w-full",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "absolute top-2 left-2 z-10 text-[10px] text-gray-700 bg-white/90 border border-gray-200 p-2 rounded pointer-events-none font-mono shadow-sm",
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  "OBJ POS: " +
                                    _vm._s(_vm.meshStats.pos.x) +
                                    ", " +
                                    _vm._s(_vm.meshStats.pos.y) +
                                    ", " +
                                    _vm._s(_vm.meshStats.pos.z)
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "OBJ ROT: " +
                                    _vm._s(_vm.meshStats.rot.x) +
                                    "°, " +
                                    _vm._s(_vm.meshStats.rot.y) +
                                    "°, " +
                                    _vm._s(_vm.meshStats.rot.z) +
                                    "°"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "CAM ZOOM: " + _vm._s(_vm.camStats.zoom) + "x"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "CAM FOV: " + _vm._s(_vm.camStats.fov) + "°"
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "absolute top-2 right-2 flex flex-col gap-1 z-10 bg-white/80 border border-gray-200 p-1 rounded shadow-sm",
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "w-8 h-8 flex items-center justify-center bg-gray-200 hover:bg-gray-300 text-gray-800 rounded text-xl font-bold",
                                  attrs: { title: "Zoom In" },
                                  on: { click: _vm.zoom3DIn },
                                },
                                [_vm._v("\n                +\n              ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "w-8 h-8 flex items-center justify-center bg-gray-200 hover:bg-gray-300 text-gray-800 rounded text-xl font-bold",
                                  attrs: { title: "Zoom Out" },
                                  on: { click: _vm.zoom3DOut },
                                },
                                [_vm._v("\n                -\n              ")]
                              ),
                              _vm._v(" "),
                              _c("hr", { staticClass: "border-gray-300 my-1" }),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "w-8 h-8 flex items-center justify-center bg-gray-200 hover:bg-gray-300 text-gray-800 rounded text-xs font-bold",
                                  attrs: { title: "Rotate +X" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.rotateMesh("x", 1)
                                    },
                                  },
                                },
                                [_vm._v("\n                +X\n              ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "w-8 h-8 flex items-center justify-center bg-gray-200 hover:bg-gray-300 text-gray-800 rounded text-xs font-bold",
                                  attrs: { title: "Rotate -X" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.rotateMesh("x", -1)
                                    },
                                  },
                                },
                                [_vm._v("\n                -X\n              ")]
                              ),
                              _vm._v(" "),
                              _c("hr", { staticClass: "border-gray-300 my-1" }),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "w-8 h-8 flex items-center justify-center bg-gray-200 hover:bg-gray-300 text-gray-800 rounded text-xs font-bold",
                                  attrs: { title: "Rotate +Y" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.rotateMesh("y", 1)
                                    },
                                  },
                                },
                                [_vm._v("\n                +Y\n              ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "w-8 h-8 flex items-center justify-center bg-gray-200 hover:bg-gray-300 text-gray-800 rounded text-xs font-bold",
                                  attrs: { title: "Rotate -Y" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.rotateMesh("y", -1)
                                    },
                                  },
                                },
                                [_vm._v("\n                -Y\n              ")]
                              ),
                              _vm._v(" "),
                              _c("hr", { staticClass: "border-gray-300 my-1" }),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "w-8 h-8 flex items-center justify-center bg-gray-200 hover:bg-gray-300 text-gray-800 rounded text-xs font-bold",
                                  attrs: { title: "Rotate +Z" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.rotateMesh("z", 1)
                                    },
                                  },
                                },
                                [_vm._v("\n                +Z\n              ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "w-8 h-8 flex items-center justify-center bg-gray-200 hover:bg-gray-300 text-gray-800 rounded text-xs font-bold",
                                  attrs: { title: "Rotate -Z" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.rotateMesh("z", -1)
                                    },
                                  },
                                },
                                [_vm._v("\n                -Z\n              ")]
                              ),
                              _vm._v(" "),
                              _c("hr", { staticClass: "border-gray-300 my-1" }),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "w-8 h-8 flex items-center justify-center bg-gray-200 hover:bg-gray-300 text-gray-800 rounded text-[10px] font-bold",
                                  attrs: { title: "Increase FOV" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeFOV(5)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                FOV+\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "w-8 h-8 flex items-center justify-center bg-gray-200 hover:bg-gray-300 text-gray-800 rounded text-[10px] font-bold",
                                  attrs: { title: "Decrease FOV" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeFOV(-5)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                FOV-\n              "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("input", {
                ref: "mappingFileInput",
                staticClass: "hidden",
                attrs: { type: "file", accept: ".json" },
                on: { change: _vm.onMappingFileChange },
              }),
              _vm._v(" "),
              _vm.showVideoModal
                ? _c(
                    "div",
                    {
                      staticClass:
                        "fixed inset-0 z-50 flex items-center justify-center bg-gray-900/40 backdrop-blur-sm",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "bg-white border border-gray-200 rounded-xl p-6 max-w-md w-full shadow-2xl space-y-5",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "flex justify-between items-center",
                            },
                            [
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "text-xl font-bold text-gray-900 flex items-center gap-2",
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "h-6 w-6 text-brand",
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 20 20",
                                        fill: "currentColor",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z",
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(
                                    "\n              Export as Video\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "text-gray-400 hover:text-gray-700",
                                  attrs: { disabled: _vm.isVideoGenerating },
                                  on: {
                                    click: function ($event) {
                                      _vm.showVideoModal = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "h-6 w-6",
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M6 18L18 6M6 6l12 12",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.isVideoGenerating
                            ? _c("div", { staticClass: "space-y-4" }, [
                                _c("div", [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "block text-sm font-medium text-gray-600 mb-2",
                                    },
                                    [_vm._v("Resolution")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "grid grid-cols-3 gap-2 mb-3",
                                    },
                                    _vm._l(
                                      [
                                        { l: "1K", w: 1920, h: 1080 },
                                        { l: "2K", w: 2560, h: 1440 },
                                        { l: "4K", w: 3840, h: 2160 },
                                      ],
                                      function (res) {
                                        return _c(
                                          "button",
                                          {
                                            key: res.l,
                                            staticClass:
                                              "py-1.5 px-2 rounded bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-200 text-xs font-bold transition-colors",
                                            on: {
                                              click: function ($event) {
                                                return _vm.setResolution(
                                                  res.w,
                                                  res.h
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(res.l) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "grid grid-cols-2 gap-4" },
                                    [
                                      _c("div", [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "text-[10px] uppercase font-bold text-gray-400 block mb-1",
                                          },
                                          [_vm._v("Width")]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model.number",
                                              value: _vm.videoSettings.width,
                                              expression: "videoSettings.width",
                                              modifiers: { number: true },
                                            },
                                          ],
                                          staticClass:
                                            "w-full bg-white border border-gray-300 rounded px-2 py-1.5 text-sm text-gray-900 focus:outline-none focus:ring-1 focus:ring-brand",
                                          attrs: { type: "number" },
                                          domProps: {
                                            value: _vm.videoSettings.width,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.videoSettings,
                                                "width",
                                                _vm._n($event.target.value)
                                              )
                                            },
                                            blur: function ($event) {
                                              return _vm.$forceUpdate()
                                            },
                                          },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "text-[10px] uppercase font-bold text-gray-400 block mb-1",
                                          },
                                          [_vm._v("Height")]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model.number",
                                              value: _vm.videoSettings.height,
                                              expression:
                                                "videoSettings.height",
                                              modifiers: { number: true },
                                            },
                                          ],
                                          staticClass:
                                            "w-full bg-white border border-gray-300 rounded px-2 py-1.5 text-sm text-gray-900 focus:outline-none focus:ring-1 focus:ring-brand",
                                          attrs: { type: "number" },
                                          domProps: {
                                            value: _vm.videoSettings.height,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.videoSettings,
                                                "height",
                                                _vm._n($event.target.value)
                                              )
                                            },
                                            blur: function ($event) {
                                              return _vm.$forceUpdate()
                                            },
                                          },
                                        }),
                                      ]),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "block text-sm font-medium text-gray-600 mb-2",
                                    },
                                    [_vm._v("Rotation Axis")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "grid grid-cols-3 gap-2" },
                                    _vm._l(["x", "y", "z"], function (axis) {
                                      return _c(
                                        "button",
                                        {
                                          key: axis,
                                          class: [
                                            "py-2 px-3 rounded-md text-sm font-bold capitalize transition-colors",
                                            _vm.videoSettings.axis === axis
                                              ? "bg-brand text-white"
                                              : "bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-200",
                                          ],
                                          on: {
                                            click: function ($event) {
                                              _vm.videoSettings.axis = axis
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(axis) +
                                              "\n                "
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "grid grid-cols-2 gap-4" },
                                  [
                                    _c("div", [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "block text-sm font-medium text-gray-600 mb-1",
                                        },
                                        [_vm._v("Duration (seconds)")]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model.number",
                                            value: _vm.videoSettings.duration,
                                            expression:
                                              "videoSettings.duration",
                                            modifiers: { number: true },
                                          },
                                        ],
                                        staticClass:
                                          "w-full bg-white border border-gray-300 rounded px-3 py-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-brand",
                                        attrs: {
                                          type: "number",
                                          min: "1",
                                          max: "60",
                                        },
                                        domProps: {
                                          value: _vm.videoSettings.duration,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.videoSettings,
                                              "duration",
                                              _vm._n($event.target.value)
                                            )
                                          },
                                          blur: function ($event) {
                                            return _vm.$forceUpdate()
                                          },
                                        },
                                      }),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "block text-sm font-medium text-gray-600 mb-1",
                                        },
                                        [_vm._v("Turns")]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model.number",
                                            value: _vm.videoSettings.loops,
                                            expression: "videoSettings.loops",
                                            modifiers: { number: true },
                                          },
                                        ],
                                        staticClass:
                                          "w-full bg-white border border-gray-300 rounded px-3 py-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-brand",
                                        attrs: {
                                          type: "number",
                                          min: "1",
                                          max: "20",
                                        },
                                        domProps: {
                                          value: _vm.videoSettings.loops,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.videoSettings,
                                              "loops",
                                              _vm._n($event.target.value)
                                            )
                                          },
                                          blur: function ($event) {
                                            return _vm.$forceUpdate()
                                          },
                                        },
                                      }),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "block text-sm font-medium text-gray-600 mb-2",
                                    },
                                    [_vm._v("Background Color")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "grid grid-cols-2 gap-3" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          class: [
                                            "py-2 px-3 rounded-md text-sm font-bold transition-all flex items-center justify-center gap-3 bg-white border",
                                            _vm.videoSettings.background ===
                                            "white"
                                              ? "ring-2 ring-brand border-transparent text-gray-900"
                                              : "border-gray-200 text-gray-600 hover:bg-gray-50",
                                          ],
                                          on: {
                                            click: function ($event) {
                                              _vm.videoSettings.background =
                                                "white"
                                            },
                                          },
                                        },
                                        [
                                          _c("span", {
                                            staticClass:
                                              "w-4 h-4 rounded-full bg-white shadow-sm ring-1 ring-black/10",
                                          }),
                                          _vm._v(
                                            "\n                  White\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          class: [
                                            "py-2 px-3 rounded-md text-sm font-bold transition-all flex items-center justify-center gap-3 bg-white border",
                                            _vm.videoSettings.background ===
                                            "black"
                                              ? "ring-2 ring-brand border-transparent text-gray-900"
                                              : "border-gray-200 text-gray-600 hover:bg-gray-50",
                                          ],
                                          on: {
                                            click: function ($event) {
                                              _vm.videoSettings.background =
                                                "black"
                                            },
                                          },
                                        },
                                        [
                                          _c("span", {
                                            staticClass:
                                              "w-4 h-4 rounded-full bg-black shadow-sm ring-1 ring-black/10",
                                          }),
                                          _vm._v(
                                            "\n                  Black\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "w-full py-3 bg-brand hover:bg-brand-dark rounded-lg font-bold text-white transition-all transform hover:scale-[1.02] active:scale-[0.98] shadow-md flex items-center justify-center gap-2",
                                    on: { click: _vm.generateVideo },
                                  },
                                  [
                                    _vm._v(
                                      "\n              Generate Video\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _c("div", { staticClass: "space-y-6 py-4" }, [
                                _c("div", { staticClass: "text-center" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "text-sm text-gray-500 mb-2",
                                    },
                                    [
                                      _vm._v(
                                        "\n                Rendering Video...\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-2xl font-bold text-brand",
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            Math.round(_vm.videoProgress)
                                          ) +
                                          "%\n              "
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "w-full bg-gray-200 rounded-full h-3 overflow-hidden border border-gray-300",
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "bg-brand h-full transition-all duration-300",
                                      style: { width: _vm.videoProgress + "%" },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "w-full py-2 text-white bg-red-600 hover:bg-red-700 rounded-lg text-sm font-semibold transition-colors",
                                    on: { click: _vm.abortVideoGeneration },
                                  },
                                  [
                                    _vm._v(
                                      "\n              Cancel\n            "
                                    ),
                                  ]
                                ),
                              ]),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showRecoveryModal
                ? _c(
                    "div",
                    {
                      staticClass:
                        "fixed inset-0 z-50 flex items-center justify-center bg-gray-900/40 backdrop-blur-sm",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "bg-white border border-gray-200 rounded-xl p-6 max-w-md w-full shadow-2xl space-y-4",
                        },
                        [
                          _c(
                            "h3",
                            { staticClass: "text-xl font-bold text-gray-900" },
                            [
                              _vm._v(
                                "\n            Restore Mappings?\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "text-gray-600" }, [
                            _vm._v(
                              "\n            Previous mapping configuration found for this image. How would you like to proceed?\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "space-y-3 pt-2" }, [
                            _c(
                              "button",
                              {
                                class: [
                                  "w-full py-3 rounded-lg font-bold transition-all flex items-center justify-center gap-2",
                                  _vm.tempMappingData &&
                                  !_vm.loadingStates.loadSaved
                                    ? "bg-brand hover:bg-brand-dark text-white shadow-md"
                                    : "bg-gray-200 text-gray-400 cursor-not-allowed",
                                ],
                                attrs: {
                                  disabled:
                                    !_vm.tempMappingData ||
                                    _vm.loadingStates.loadSaved,
                                },
                                on: { click: _vm.loadSavedMapping },
                              },
                              [
                                _vm.loadingStates.loadSaved
                                  ? _c("span", {
                                      staticClass: "button-spinner",
                                    })
                                  : _c("span", [
                                      _vm._v("Load Saved (Browser)"),
                                    ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "w-full py-3 bg-brand hover:bg-brand-dark text-white rounded-lg font-bold transition-all flex items-center justify-center gap-2 shadow-md",
                                attrs: { disabled: _vm.loadingStates.loadFile },
                                on: { click: _vm.triggerMappingFileClick },
                              },
                              [
                                _vm.loadingStates.loadFile
                                  ? _c("span", {
                                      staticClass: "button-spinner",
                                    })
                                  : _c("span", [_vm._v("Upload File (.json)")]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "w-full py-3 bg-brand hover:bg-brand-dark text-white rounded-lg font-bold transition-all flex items-center justify-center gap-2 shadow-md",
                                on: {
                                  click:
                                    _vm.openSelectFolderModalForMappingJson,
                                },
                              },
                              [_c("span", [_vm._v("Load From File Browser")])]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "w-full py-3 text-gray-800 bg-gray-200 hover:bg-gray-300 rounded-lg font-bold transition-colors flex items-center justify-center gap-2",
                                on: { click: _vm.cancelRecovery },
                              },
                              [_c("span", [_vm._v("Cancel (New Mapping)")])]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("h1", { staticClass: "text-3xl font-bold text-gray-900" }, [
        _vm._v("\n            Texture to 3D Render\n          "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loader-container" }, [
      _c("div", { staticClass: "brand-spinner" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "text-gray-500 text-center max-w-sm mb-8" }, [
      _vm._v("\n              Drag and drop your image here, or "),
      _c("span", { staticClass: "text-brand font-bold underline" }, [
        _vm._v("click to browse"),
      ]),
      _vm._v(
        ".\n              Supports JPG, PNG and other image formats.\n            "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "h2",
      {
        staticClass:
          "text-xl font-semibold mb-2 flex items-center justify-between text-gray-900",
      },
      [_c("span", [_vm._v("3D Preview")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }